import ModalComponent from '@components/common/Modal';
import { Input } from 'antd';
import classNames from 'classnames';
import { IOrderManager } from 'models/OrderManager';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IDeclineOrder {
  isOpen: boolean;
  rowSelect?: IOrderManager;
  callBackClose: () => any;
  callBackRefresh: () => any;
  callBackDelete: (data) => any;
}

export default function DeclineOrderModal(props: IDeclineOrder) {
  const { t } = useTranslation();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [reason, setReason] = useState<string>('');
  const [isRequire, setIsRequire] = useState<boolean>(false);
  const handleOk = () => {
    try {
      if (props && reason.length !== 0) {
        setConfirmLoading(true);
        // xoá ở local
        console.log(props.rowSelect);
        setIsRequire(false);

        props.callBackDelete(reason);
        //      gọi api
        //     await BusManagementServiceApi.DeleteFeeForPenalty(props.rowSelect.CompanyId!, props.rowSelect.Id).then(res => {
        //         if (res.data.Status === 1) {
        //             Toast(t("ManagerBus.FeedForViolationPenalties.SuccessMessage.Delete"), ToastType.SUCCESS)
        //             props.callBackClose()
        //             props.callBackRefresh()
        //         }
        //     })

        // cần hiện popup cập nhật xong
        // có thể đặt trong kq của api trả về
        setTimeout(() => {
          setConfirmLoading(false);
          props.callBackClose();
        }, 1000);
      } else {
        setIsRequire(true);
      }
    } catch (error) {
      console.log('need reason', error);
    }
  };

  const handleCancel = () => {
    props.callBackClose();
  };
  return (
    <>
      <ModalComponent
        modalTitle={t('OrganizedSales.OrderManager.ModifyOrder.DeclineOrderModal.Title')}
        modalType="decline"
        modalSize="auto"
        visible={props.isOpen}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        justifyMiddle={true}
      >
        {/* <div lassName="flex space-x-8 align-middle text-sm">{t('DataManagement.Staff.Delete.Message')}</div> */}

        <label className="text-base p-2">{t('OrganizedSales.OrderManager.ModifyOrder.DeclineOrderModal.Reason')}</label>
        <Input value={reason} placeholder={t('Input.placeholder')} onChange={e => setReason(e.target.value)} />
        <label
          className={classNames(isRequire && reason.length === 0 ? 'text-red-500 block' : 'hidden', 'text-sm  p-2')}
        >
          {t('Input.FieldError.RequireText')}
        </label>
      </ModalComponent>
    </>
  );
}
